import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { cloneDeep } from 'lodash-es';
import { Observable, Subscription } from 'rxjs';
import { ConfigurationType } from '../../../../domain/consts';
import { Dictionary, DictionaryType } from '../../../../domain/dictionary.model';
import { OfferHeader } from '../../../../domain/offer.domain';
import { PolicyHeader } from '../../../../domain/policy.model';
import { OfferFilter, PolicyFilter } from '../../../../domain/registry.domain';
import { EntityRole, SystemUser } from '../../../../domain/user.model';

import { DictionaryState } from '../../store/dictionary.state';
import { RegistryAction } from '../../store/registry.action';
import { RegistryState } from '../../store/registry.state';
import { UserState } from '../../store/user.state';

@Component({
    selector: 'app-registry',
    templateUrl: './registry.component.html'
})
export class RegistryComponent implements OnInit, OnDestroy {

    offerRequest: OfferFilter;
    policyRequest: PolicyFilter;

    selectedIndex: number = 0;

    subscriptions: Subscription[] = [];
    @Select(RegistryState.getOffers) offers$: Observable<OfferHeader[]>;
    @Select(RegistryState.getPolicies) policies$: Observable<PolicyHeader[]>;
    @Select(DictionaryState.getDictionaries) dictionaries$: Observable<{ [key: string]: Dictionary }>;
    dictionaryTypes = DictionaryType;
    configurationType = ConfigurationType;
    user: SystemUser;
    entityRole = EntityRole;
    hasSalesColumn = [
        EntityRole.AGENT,
        EntityRole.SALES_MANAGER,
        EntityRole.HEADQUATERS,
    ];

    get isSeller() {
        return ([EntityRole.WORKER, EntityRole.AGENT, EntityRole.DIRECT_SALES] as EntityRole[]).indexOf(this.user.entityRole) !== -1;
    }

    constructor(private store: Store,
                private router: Router,
                private route: ActivatedRoute,
    ) {
    }

    ngOnInit(): void {
        this.selectedIndex = this.route.snapshot.params.type === 'policy' ? 1 : 0;
        this.router.navigate(['.'], {replaceUrl: true, relativeTo: this.route, queryParams: {}});
        this.subscriptions.push(
            this.store.select(UserState.getUser).subscribe(user => this.user = user),
            this.store.select(RegistryState.getOfferFilter)
                .subscribe(filter => this.offerRequest = cloneDeep(filter)),
            this.store.select(RegistryState.getPolicyFilter)
                .subscribe(filter => this.policyRequest = cloneDeep(filter)),
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe());
    }


    searchOffers() {
        this.store.dispatch(new RegistryAction.GetOffers(this.offerRequest));
    }

    csvOffers() {
        this.store.dispatch(new RegistryAction.GetOffersCSV(this.offerRequest));
    }

    onKeyDownOffers($event: KeyboardEvent) {
        if ($event.key === 'Enter') {
            this.searchOffers();
        }
    }

    searchPolicies() {
        this.store.dispatch(new RegistryAction.GetPolicies(this.policyRequest));
    }

    csvPolicies() {
        this.store.dispatch(new RegistryAction.GetPoliciesCSV(this.policyRequest));
    }

    onKeyDownPolicies($event: KeyboardEvent) {
        if ($event.key === 'Enter') {
            this.searchPolicies();
        }
    }

    indexChanged($event: number) {
        const path = $event === 0 ? 'offer' : 'policy';
        this.router.navigate(['/registry', path], {replaceUrl: true, relativeTo: this.route, queryParams: {}});
    }

    offerLink(offer: OfferHeader) {
        if (offer.frontier) {
            return this.isSeller
                ? ['/frontier', offer.id, 'card']
                : ['/frontier', offer.id, 'summary'];
        }
        return ['/calculation', offer.id, 'card'];
    }
}
